import type { OrderCompensationType } from '../enums/OrderCompensationType'

export class OrderCompensationEntity {
  id?: string
  orderId?: string
  orderReferenceCode?: string | null
  amount?: number
  note?: string | null
  type?: OrderCompensationType
  driverId?: number | null
  driverFullName?: string | null
  createdAt?: string
}
